export default "__VITE_ASSET__a03828ee__"